const InstitutionServiceCodes = Object.freeze({
  ServicePurchase: 382,
});

export default InstitutionServiceCodes;
